import { type MicrofrontendNS } from '../microfrontend/index.js';

type TagOptions = {
  microfrontendName: string;
  imageVersion: MicrofrontendNS.ImageVersion;
  runtimeName: MicrofrontendNS.RuntimeName;
};

export function generateTagName(options: TagOptions) {
  // https://html.spec.whatwg.org/multipage/scripting.html#valid-custom-element-name
  return `cian-mf-ui-${options.microfrontendName}-${options.imageVersion}-${options.runtimeName}`.replace(
    // eslint-disable-next-line no-misleading-character-class
    /(?:[^\x2D.0-9_a-z\xB7\xC0-\xD6\xD8-\xF6\xF8-\u037D\u037F-\u1FFF\u200C\u200D\u203F\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[^\uD800-\uDB7F][\uDC00-\uDFFF])/g,
    '_',
  );
}
